import { get1099FilingThreshold } from '../../appRedux/services/VendorService';

// Used until the API answers or if it fails; same rule as the SQL function ($2,000 from 2026, $600 before).
export function fallbackFilingThreshold(taxYear) {
    return taxYear >= 2026 ? 2000 : 600;
}

const thresholdsByYear = {};

// The year's 1099 filing threshold, from the SQL rule the 1099 reports use. The W-9 placeholder rule applies the
// Non-Employee Compensation / Rent / Other amount to every vendor type.
export function loadFilingThreshold(taxYear) {
    if (!thresholdsByYear[taxYear]) {
        thresholdsByYear[taxYear] = get1099FilingThreshold(taxYear)
            .then((res) => {
                const row = (res.data || []).find((t) => t.vendorType === 'Non-Employee Compensation');
                return row ? Number(row.filingThreshold) : fallbackFilingThreshold(taxYear);
            })
            .catch(() => {
                delete thresholdsByYear[taxYear];
                return fallbackFilingThreshold(taxYear);
            });
    }
    return thresholdsByYear[taxYear];
}

// Stores the answer under its own year, so a late answer for another year is never used.
export function storeFilingThreshold(component, taxYear) {
    loadFilingThreshold(taxYear).then((amount) =>
        component.setState((s) => ({ filingThresholds: { ...(s.filingThresholds || {}), [taxYear]: amount } })));
}

// The threshold for the year on screen: the loaded amount, else the fallback for that year.
export function filingThresholdFor(filingThresholds, taxYear) {
    const amount = filingThresholds && filingThresholds[taxYear];
    return amount != null ? amount : fallbackFilingThreshold(taxYear);
}
